import React, { useState, useEffect } from "react";
import MakePicksForm from "./MakePicksForm";
import ConfidenceStep from "./ConfidenceStep";
import "../styles/PicksModal.css";

const PicksModal = ({ onClose, currentUserId, onSaveAndClose }) => {
  const [nextStep, setNextStep] = useState(false);
  const [userPicks, setUserPicks] = useState({});
  const [currentSeason, setCurrentSeason] = useState(null);
  const handleBackToPicks = () => {setNextStep(false);
};


  const API_BASE_URL = process.env.REACT_APP_API_URL || "";

  // Fetch current season when modal mounts
  useEffect(() => {
    const fetchCurrentSeason = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/api/seasons/current`);
        const data = await response.json();
        setCurrentSeason(data.season); // e.g., "2025"
      } catch (error) {
        console.error("Error fetching current season:", error);
      }
    };
    fetchCurrentSeason();
  }, [API_BASE_URL]);

  // Function to handle transitioning to the Confidence Step
  const handleNextStep = () => {
    if (Object.keys(userPicks).length === 0) {
      alert("Please make your picks before proceeding.");
      return;
    }
    setNextStep(true);
  };

  // Function to collect picks from MakePicksForm
  const collectPicks = (picks) => {
    setUserPicks(picks);
  };

  return (
      <div className="modal-overlay">
        <div className={`modal-content ${nextStep ? "confidence-step" : "make-picks-step"}`}>
          {nextStep && (
            <div className="back-button-container">
              <button className="back-button" onClick={() => setNextStep(false)}>
                ← Back to Picks
              </button>
            </div>
          )}

          {!nextStep ? (
            <MakePicksForm
              collectPicks={collectPicks}
              userPicks={userPicks}
            />
          ) : (
            <ConfidenceStep
              userPicks={userPicks}
              onClose={onClose}
              currentUserId={currentUserId}
              onSaveAndClose={onSaveAndClose}
              currentSeason={currentSeason}
              onBack={handleBackToPicks}
            />
          )}

          <div className="modal-footer">
            {!nextStep && (
              <button className="next-step-button" onClick={handleNextStep}>
                Next Step
              </button>
            )}
            {!nextStep && (
              <button className="modal-close-button" onClick={onClose}>
                Close
              </button>
            )}
          </div>
        </div>
      </div>


  );
};

export default PicksModal;
